import styled from 'styled-components'


const FlexContainer = styled.div`
    display: flex;
    flex-direction: row;
` 

export default FlexContainer;